const keys = {
  baseSegment: {
    placeholders: {
      address: '500 Avenue des Pins, Montreal',
      addressCity: 'City',
      addressStreetName: 'Street name',
      addressStreetNumber: 'Number',
      addressUnit: 'Unit number',
      areaNotAvailable: {
        email: 'Email',
      },
      constructionYear: 'ex. 2016',
      currentInsurer: 'Ex. Intact',
      email: 'Email',
      firstName: 'First name',
      genericDate: 'dd/mm/yyyy',
      homeReconstructionCost: 'ex. 250 000',
      lastName: 'Last name',
      monthDate: '',
      numberOfUnits: '75',
      occupation: 'Ex. Medical',
      phoneNumber: 'ex. (514) 555-5555',
      postalCode: 'Postal Code',
      productNotAvailable: {
        email: 'Email',
        renewalMonth: 'Renewal Month',
      },
      dogBreed: 'ex. Golden retriever, poodle',
      province: 'Province',
      waterTankYear: 'ex. 2015',
      electricalSystemReplacementYear: 'ex. 2015',
      plumbingReplacementYear: 'ex. 2015',
      windowsAndDoorsReplacementYear: 'ex. 2015',
    },
    titles: {
      additionalDrivers: 'Please add all additional drivers',
      additionalHeating: 'Do you have any additional heating systems?',
      additionalOilTankLocation: 'Where is the oil tank of the additional heating system located?',
      address: 'What is your address?',
      addressNotCompleted: 'Can you please complete the missing information?',
      addressNotFound: "These things happen. Let's try it again.",
      electricalDetails: 'What is the amperage of your home?',
      electricalWiringType: 'What kind of electrical wiring do you have in the entire building?',
      electricalSystemReplacementYear: 'What year was the electrical panel and wiring last replaced at 100%?',
      plumbingReplacementYear: 'What year was the plumbing last replaced at 100%?',
      windowsAndDoorsReplacementYear: 'What year were the windows and doors last replaced at 100%?',
      hasBackwaterValve: 'Do you have a backwater valve?',
      hasFrenchDrain: 'Do you have a french drain?',
      basementCondition: 'Is there a basement in your home?',
      birthday: 'We don’t want to be rude, but what’s your birthday?',
      businessOccupancy: 'Are you located in a building where businesses operate?',
      carClaims: 'Please add every car accidents or losses in the last 6 years',
      carLegalConsent: {
        quebec:
          'To help you save an additional 25%, we’ll need to do a soft credit check and verify your claims history in the Fichier Central des Sinistres Automobiles (FCSA)',
        ontario: 'To help you save up to 25%, we’ll need to verify the Motor Vehicle Records (MVR) and DASH.',
      },
      carCreditors: 'Who is financing your vehicle and what is their address?', // TODO: pluralization?
      carContinuouslyCoverage:
        'Do you currently have a car insurance? If yes, for how long have you been continuously insured?',
      cars: "Let's get started, tell us about your cars.",
      carsDriverAssignments: 'Assign a main and occasional driver to each car.',
      dogBreed: 'What is the breed of your dog?',
      disclaimer: 'Last step before we get to your quote! Please, review each item below and check all that apply.',
      discounts:
        'Now it’s time to find out if you’re eligible for any discounts. Please select everything below that describes you.',
      driverLicenceDetails: {
        quebec: 'How old were you when you first got your driver’s licence in Quebec?',
        ontario: 'How old were you when you first got your driver’s licence in Ontario?',
      },
      drivingConvictions: 'Please add every driving conviction you got in the last 5 years',
      email: 'What is your email address?',
      floorNumber: 'What floor do you live on?',
      garages: 'Does your home have a garage?',
      gender: 'How do you describe yourself?',
      homeAmenities: 'We just have to know few more details about your home',
      homeClaims: 'In the last 8 years, have you filed any property insurance claims?',
      homeContinuouslyCoverage:
        'Do you have an active home insurance policy ? If yes, for how long have you been continuously insured?',
      homeLegalConsent: 'To help you save an additional 25%, we’ll need to do a soft credit check.',
      homeExteriorMaterial: "How would you describe your home's exterior?",
      homeReconstructionCost: 'Please confirm your home reconstruction cost with equivalent materials.',
      homeSecurity: 'Select everything below that describes your household security:',
      homeStructureCondition: 'Tell us more about your home’s structure',
      homeStructureType: "How would you describe your home's construction type?",
      isOwner: 'Do you rent or own your home?',
      insulationType: 'What type of insulation is used in the entire building?',
      moveInDetails: {
        car: 'When did you move to your current address?',
        home: {
          condo: 'When did you or will you move to this condo?',
          homeowner: 'When did you or will you move to this house?',
          tenant: 'When did you or will you move to this apartment?',
        },
      },
      numberOfMortgages: {
        home: {
          condo: 'Do you have a mortgage on your condo?',
          homeowner: 'Do you have a mortgage on your house?',
        },
      },
      occupation: 'What is your field of work?',
      oilTankLocation: 'Where is the oil tank located?',
      ownershipType: 'Which type of property do you own?',
      pets: 'Do you have any pets?',
      phoneNumber: 'What is your phone number?',
      pool: 'Do you have a swimming pool?',
      spa: 'Do you have a spa?',
      primaryHeating: 'What is your primary heating system?',
      propertyCharacteristics: 'Please confirm the following information about your address.',
      registeredCarOwners: 'Besides you, are there other registered owners on any of the cars?',
      userName: 'Can you please tell us your name?',
      unemployed: 'Can you confirm your occupation?',
      waterHeatingType: 'What type of hot water/steam heating system do you have?',
      waterTankYear: 'What’s the year on your hot water tank?',
    },
    subtitles: {
      additionalHeating: 'The heating systems must be certified and installed by a professional.',
      businessOccupancy: 'Any businesses such as a restaurant, store, dental clinic, etc.',
      carClaims:
        'Omitting information can affect the accuracy of your quote and insurance companies will pull this information before selling you a policy.',
      carLegalConsent: {
        quebec: 'This will not affect your credit score nor your claims history.',
        ontario: 'This will not affect your driving record nor your claims history.',
      },
      carCreditors: 'Note that incorrect answers may invalidate the quote.',
      discounts: 'If you are an entrepreneur or freelancer, you can select work full-time.',
      dogBreed: 'List all the dog breeds if you own more than one dog.',
      email: 'This is where we will send a copy of your quote.',
      homeLegalConsent: 'This will not affect your credit score.',
      homeReconstructionCost:
        'The reconstruction cost is not the same as market value or the municipal assessed value. It excludes the value of the land.',
      homeSecurity:
        'Professionally monitored alarms notify a central station when it is activated and have to be installed by a professional.',
      numberOfClaims: 'We’re not here to judge. This information will help us create an accurate quote.',
      phoneNumber: 'We will only call you if we can’t communicate the information by SMS.',
      primaryHeating: 'Heating system must be certified and installed by a professional.',
      userName: {
        car: 'To get the best prices, write your full name as it is on your driver’s licence.',
        home: 'You can add another person to your policy later.',
      },
      waterTankYear: 'If you do not have a tank in your unit, ask your building manager.',
      yearsContinuouslyInsured: 'Please select "I’m not insured" if your name is not on the policy.',
    },
    helpers: {
      // Car
      carContinuouslyCoverage: {
        description:
          'Calculate how many years you have had uninterrupted car insurance. For example, if you have been insured with Insurer A for 2 years and have changed to Insurer B (without any delay when you were no longer insured) for the last 3 years, select 5 years.',
      },
      registeredCarOwners: {
        description:
          'A person is a registered car owner if their name is on the car registration certificate. This person, considered co-insured, can act on your behalf to modify or cancel the policy.',
      },
      carLegalConsent: {
        ontario: {
          description:
            'Driver and Auto Search History (DASH) is a policy and claims information system designed to retrieve driver and auto data for the Canadian insurance industry.',
        },
      },

      // Home
      primaryHeating: {
        cells: {
          primaryHeating: {
            description:
              'The heating system must be certified and installed by a professional.<0></0><1></1> A heating system is certified if it has been accepted by the Canadian Standards Association (CSA), the Canadian Gas Association (CGA) and approved by Underwriters Laboratories of Canada (ULC), Warnock Hersey (W-H), Omni Test Laboratories (OTL) or Electrical Testing Laboratories (ETL).',
          },
        },
      },
      additionalHeating: {
        cells: {
          additionalHeating: {
            description:
              'All heating systems must be certified and installed by a professional.<0></0><1></1> A heating system is certified if it has been accepted by the Canadian Standards Association (CSA), the Canadian Gas Association (CGA) and approved by Underwriters Laboratories of Canada (ULC), Warnock Hersey (W-H), Omni Test Laboratories (OTL) or Electrical Testing Laboratories (ETL).',
          },
        },
      },
      homeStructureType: {
        cells: {
          detached: {
            title: 'Detached',
            description:
              'A detached dwelling has no buildings attached to it on any side (except its own garage or shed).',
          },
          semiDetached: {
            title: 'Semi Detached',
            description:
              'The dwelling is attached to another home or building (except its own garage or shed) but only on 1 side, and the other sides are open.',
          },
          inRowBuilding: {
            title: 'In Row Building',
            description: 'The Dwelling is located in the middle of three or more dwellings joined side by side.',
          },
          endRowBuilding: {
            title: 'End Row Building',
            description: 'The Dwelling is located at the end of three or more dwellings joined side by side.',
          },
        },
      },
      electricalDetails: {
        description:
          "Amperage is the strength of the current of electricity in amperes (AMP) in a building. Search for a specification label on your home's electrical box or ask an electrician for the information.",
      },
      homeExteriorMaterial: {
        cells: {
          aluminium: {
            title: 'Aluminium',
            description: 'The outer coating of the building is mainly made of aluminium.',
          },
          masonry: {
            title: 'Masonry',
            description: 'The outer coating of the building is mainly made of fieldstones.',
          },
          stone: {
            title: 'Stone',
            description: 'The outer coating of the building is mainly made of stone.',
          },
          stuco: {
            title: 'Stuco / Aggregate',
            description:
              'The outer coating of the building is mainly made of stucco or aggregate. These materials are plasters made from a mix of cement, sand and water.',
          },
          vinyl: {
            title: 'Vinyl',
            description: 'The outer coating of the building is mainly made of vinyl.',
          },
          wood: {
            title: 'Wood',
            description: 'The outer coating of the building is mainly made of wood, engineered wood or wood fiber.',
          },
        },
      },
      homeReconstructionCost: {
        cells: {
          homeReconstructionCost: {
            description:
              'The reconstruction cost is the amount to replace your home due to a total loss (the cost to demolish and rebuild), including labour and new materials. You can refer to the reconstruction cost listed in your current home insurance. <0></0><1></1> This is not the same as the market value of your home or the municipal assessed value. <2></2><3></3> Rebuilding costs may be adjusted to meet your needs when one of our brokers reviews your file. This may have an effect on your insurance premium.',
          },
        },
      },
      homeContinuouslyCoverage: {
        cells: {
          homeContinuouslyCoverage: {
            description:
              '<0>What does home insurance mean?</0><1></1> <2>Home insurance includes tenant, condo and house insurance.</2> <3></3><4></4> <5>How do I calculate?</5> <6></6> <7>Calculate how many years you have had uninterrupted home insurance. For example, if you have been insured with Insurer A for 2 years and have changed to Insurer B (without any delay when you were no longer insured) for the last 3 years, select 5 years.</7>',
          },
        },
      },
    },
    multiProductDiscount: 'Bundle Discount Unlocked',
    emailValidationWarning: 'Your email address seems unusual. Did you mean <0>{{0}}</0>?',
  },
};

export default keys;

export type TranslationKeys = typeof keys;
